import React, { useState, useEffect } from 'react';
import ModalA from './ModalA';

const Hero = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [showNameInput, setShowNameInput] = useState(false);
  const [playerName, setPlayerName] = useState('');
  const [playerData, setPlayerData] = useState(null);
  
  // Check if we have saved player data
  useEffect(() => {
    const savedPlayer = sessionStorage.getItem('currentPlayer');
    if (savedPlayer) {
      try {
        const parsedData = JSON.parse(savedPlayer);
        setPlayerData(parsedData);
      } catch (e) {
        console.error('Error parsing player data', e);
      }
    }
  }, []);

  const handleStartGame = () => {
    // If player data exists, open modal directly, otherwise show name input
    if (playerData) {
      setModalIsOpen(true);
    } else {
      setShowNameInput(true);
    }
  };
  
  const handleSubmitName = (e) => {
    e.preventDefault();
    if (playerName.trim()) {
      // Create new player with random starting coins
      const startingCoins = Math.floor(Math.random() * 1000) + 1000;
      const newPlayerData = {
        name: playerName,
        coins: startingCoins,
        joinedAt: new Date().toISOString()
      };
      
      // Save to session storage
      sessionStorage.setItem('currentPlayer', JSON.stringify(newPlayerData));
      setPlayerData(newPlayerData);
      
      // Close name input and open game
      setShowNameInput(false);
      setModalIsOpen(true);
    }
  };

  return (
<section className="hero">
  <div className="hero__particles">
    {[...Array(20)].map((_, i) => (
      <div key={i} className="hero__particle"></div>
    ))}
  </div>

  <div className="container">
  <div className="hero__wrapper">
    <div className="hero__content">
      <div className="hero__jackpot">
        <span className="hero__jackpot-label">Daily Jackpot</span>
        <span className="hero__jackpot-amount">1,000,000</span>
        <span className="hero__jackpot-currency">Coins</span>
      </div>

      <h1 className="hero__title">
        <span className="hero__title-top">Welcome to</span>
        Crazy Monkey
        <span className="hero__title-bottom">Social Casino</span>
      </h1>

      {playerData && (
        <div className="player-welcome-hero">
          Welcome back, <span className="player-name">{playerData.name}</span>!
          <div className="player-coins">
            Balance: <span className="coins-amount">{playerData.coins.toLocaleString()}</span> Coins
          </div>
        </div>
      )}

      <p className="hero__text">
        Experience Las Vegas-style thrills with no real money. Play, compete, and win virtual rewards!
      </p>

      <div className="hero__cta">
        <button className="button button--primary button--glow" onClick={handleStartGame}>
          <span className="button__icon">🎮</span>
          {playerData ? 'Continue Playing' : 'Play Now'}
        </button>
      </div>
    </div>

    <div className="hero__game-preview">
      <div className="hero__slot-machine">
        <div className="hero__reels">
          {[1, 2, 3].map((reel) => (
            <div key={reel} className="hero__reel">
              <div className="hero__symbol">🐒</div>
              <div className="hero__symbol">🍊</div>
              <div className="hero__symbol">7️⃣</div>
            </div>
          ))}
        </div>
        <button className="hero__spin-button" onClick={handleStartGame}>
          {playerData ? 'CONTINUE' : 'SPIN'}
        </button>
      </div>

      <div className="hero__features">
        <div className="feature-card">
          <div className="feature-card__icon">🎰</div>
          <h3 className="feature-card__title">Free Spins Daily</h3>
          <p className="feature-card__text">Get 100 free spins every day!</p>
        </div>

        <div className="feature-card">
          <div className="feature-card__icon">👥</div>
          <h3 className="feature-card__title">Social Gaming</h3>
          <p className="feature-card__text">Play with friends around the world</p>
        </div>
      </div>
    </div>
  </div>
</div>


  <div className="hero__decorations">
    <div className="hero__chips"></div>
    <div className="hero__cards"></div>
    <div className="hero__dice"></div>
  </div>

  {/* Nimen Syöttö -modaali */}
  {showNameInput && (
    <div className="name-input-modal">
      <div className="name-input-content">
      <h2>Enter Your Name</h2>

        <form onSubmit={handleSubmitName}>
          <input
            type="text"
            value={playerName}
            onChange={(e) => setPlayerName(e.target.value)}
            placeholder="Nimesi"
            required
            maxLength={20}
          />
          <div className="name-input-disclaimer">
          <p>By entering your name, you confirm that you are at least 18 years old and accept the terms of service.</p>

          </div>
          <button type="submit" className="button button--primary">
          Start Game
          </button>
        </form>
      </div>
    </div>
  )}

  {modalIsOpen && (
    <ModalA
      setModalOpen={setModalIsOpen}
    />
  )}
</section>

  );
};

export default Hero;